import React, { useState, useEffect, useContext } from 'react';
import Chart from '../../../../Assets/Images/spider-chart.png';
import LeadershipChart from '../report-pdf/LeadershipChart';
import GroupSpiderChart from './GroupSpiderChart';
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import GroupReportContext from '../../../../Context/GroupReportContext';

const GroupAlignmentFlowSecond = ({ apiData, previewData, reportType, pageNumber }) => {
  // console.log('GroupAlignmentFlowSecond apiData:', apiData);
  // console.log('GroupAlignmentFlowSecond previewData:', previewData);

  const { averagePercentages, averagePercentagesLeadership } = useContext(GroupReportContext)

  const [starterLabel, setStarterLabel] = useState(["HEART", "STRENGTH", "SOUL", "MIND"]);
  const [leadershipLabel, setLeadershipLabel] = useState(["COLLABORATIVE", "PERFORMANCE", "VISIONARY", "STRATEGIC"]);
  const [leadershipResult, setLeadershipResult] = useState([10, 0, 20, 0]);
  const [snapshotResult, setSnapshotResults] = useState([0, 4, 23, 20]);
  const [variablsMapArray, setVariableMapArray] = useState();

  useEffect(() => {

    if (averagePercentages && averagePercentagesLeadership) {

      const strength = averagePercentages?.find((el) => el?.name == "Strength")?.avg
      const heart = averagePercentages?.find((el) => el?.name == "Heart")?.avg
      const soul = averagePercentages?.find((el) => el?.name == "Soul")?.avg
      const mind = averagePercentages?.find((el) => el?.name == "Mind")?.avg

      const strategic = averagePercentagesLeadership?.find((el) => el?.name == "Strategic")?.avg
      const visionary = averagePercentagesLeadership?.find((el) => el?.name == "Visionary")?.avg
      const collaborative = averagePercentagesLeadership?.find((el) => el?.name == "Collaborative")?.avg
      const performance = averagePercentagesLeadership?.find((el) => el?.name == "Performance")?.avg

      setSnapshotResults([
        // averagePercentages?.[1]?.avg,
        // averagePercentages?.[0]?.avg,
        // averagePercentages?.[2]?.avg,
        // averagePercentages?.[3]?.avg,
        heart,
        strength,
        soul,
        mind
      ])

      setLeadershipResult([
        // averagePercentagesLeadership?.[2]?.avg,
        // averagePercentagesLeadership?.[3]?.avg,
        // averagePercentagesLeadership?.[1]?.avg,
        // averagePercentagesLeadership?.[0]?.avg,
        collaborative,
        performance,
        visionary,
        strategic
      ])
    }

  }, [averagePercentages, averagePercentagesLeadership])


  return (
    <div>
      <HeaderPreview />
      <div className="page">
        <style>
          {`
          .container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 60vh;
            text-align: center;
          }
          .header-text {
            font-size:24px;
            line-height:41px;
            font-weight: 700;
            color: #426B88;
            margin-bottom: 8px;
            margin-top: 19px;
          }
          .chart {
            height: 290px;
            width: 371px;
          }
          .footer {
            display: flex;
            justify-content: space-between;
            border-top: 1px solid #00577D;
            padding-top: 10px;
            margin-top: 20px;
          }
          .footerTextHeading {
            font-size: 12px;
            font-weight: 700;
            color: #76A3BE;
          }
          .footerText {
            font-size: 10px;
            color: #76A3BE;
          }
          .statement {
            font-size: 11px;
            text-align: center;
            font-weight: 400;
            color: #245775;
            line-height: 25px;
            margin-top: 8px;
          }
        `}
        </style>

        <div className="container">
          <h1 className="header-text">WHO YOU ARE vs HOW YOU LEAD</h1>
          <p className="statement">These charts reflect the combined results calculated with all the participant scores for
            Starter Quadrant and Leadership Style.</p>
          <GroupSpiderChart
            snapshotResult={snapshotResult}
            starterLabel={starterLabel}
            leadershipResult={leadershipResult}
            leadershipLabel={leadershipLabel}
          />
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default GroupAlignmentFlowSecond;
